import React from 'react';

import { shortString } from '../../../utils/global';
import NaComponent from '../../Dashboard/Lists/components/NaComponent';
import CustomTooltip from '../CustomTooltip/CustomTooltip';

type ShortStringProps = {
  name: string;
  stringLength: number;
  placement?: 'right' | 'bottom' | 'top' | 'left' | undefined;
  naSpan?: any;
  style?: any;
  show?: boolean; // default true, if false, tooltip will not be shown when string is too long.
  className?: string; // additional class for the component.
  tooltipStyle?: any;
};

export default function ShortString({
  name,
  stringLength,
  placement = 'right',
  naSpan,
  style,
  show = true,
  className = '',
  tooltipStyle = {},
}: ShortStringProps) {
  const renderString = () => {
    if (naSpan) {
      return (
        <NaComponent>
          <span style={style} className={className}>
            {shortString(name, stringLength)}
          </span>
        </NaComponent>
      );
    } else {
      return (
        <span style={style} className={className}>
          {shortString(name, stringLength)}
        </span>
      );
    }
  };

  if (name?.length > stringLength) {
    return (
      <CustomTooltip title={name} placement={placement} arrow show={show} tooltipStyle={tooltipStyle}>
        <div style={style}>{renderString()}</div>
      </CustomTooltip>
    );
  } else {
    return <div style={style}>{renderString()}</div>;
  }
}
